export default __webpack_public_path__ + "static/media/step-bg.ce3f7126.png";